export default "__VITE_ASSET__DeSOUL1K__"